export const colors = {
    alertBackground: '#E0E0E0',
    alert_low: '#29CC97',
    alert_medium: '#FEC400',
    alert_high: '#EC6666',
    white: 'white',
    black: '#252733',
    headerBackground: '#5d5d5d',
    black90: '#3E3E3E',
    black80: '#AFAFAF',
    black50: '#C5C7CD',
    black30: '#F0F1F7',
    black10: '#FCFDFE',
    background: '#F5F5F5',
    primary: '#469253',
    primary50: '#C2D6A1',
    primary25: '#E4EDD6',
    primary0: '#008000',
    primaryLight: '#4692531c',
    secondary: '#9FA2B4',
    notofication: '#F12B2C',
    newcount: '#2EB67D',
    pageBackground: '#F7F8FC',
    errors: 'red',
    inputBackground: '#FCFDFE',
    inputDisabled: 'hsl(0, 0%, 95%)',
    inputColor: 'hsl(0, 0%, 20%)',
    inputBorder: 'hsl(0, 0%, 80%)',
    statusDone: '#29CC97',
    statusWarning: '#FEC400',
    statusError: '#F12B2C',
    tabActive: '#469253',
    deleteButton: '#dc3545',
    deleteButtonHover: '#ad2a36',
    tabInactive: '#A9D6B0',
    textColor1: '#9DA3B4',
    textColor2: '#444444',
    plusButton: '#357adb',
    avatarBackground: '#76A4AE',
    maintenance_completed_status: '#ABB8C3',
    divider: '#DFE0EB',
    lightgray: '#e8e8e8',

    icons: '#000000',
    inputPlaceholderColor: 'hsl(0, 0%, 50%)',
    myBubble: 'hsl(82, 44%, 90%)',
    collaboratorBubble: 'hsl(191, 65%, 90%)',
    notificationCount: '#4282FF',
    // Ocr scanning colors
    e_no: '#f7c04a',
    serial_number: '#f777f7',
    gtin_ean: '#24d6c7',
    rsk_no: '#7606cc',
    article_no: '#f7731b',
    pnc_number: '#2660de',
    order_no: '#db232c',
    //
};

export type Colors = keyof typeof colors;
